import { ReactComponent as Laughing } from 'assets/images/videoReactions/laughing.svg';
import styled from 'styled-components/macro';

const LaughingIcon = styled(Laughing)`
  width: ${props => props.width || '24px'};
  height: ${props => props.height || '24px'};
`;

export default LaughingIcon;
